export default {
  GET_FILETYPE_LIST(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    state.fileType_list = data;
  },
  GET_ALLFILE_LIST(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
    });
    state.allFile = data;
    state.allFile_list = state.allFile.slice(0, 10);
  },
};
